import React, { useState } from "react";
import "./RentalIncome.css";
import Checkbox from "@mui/material/Checkbox";
import { useNavigate } from "react-router-dom";
const ClientDashboardAddRentalIncome = () => {
  const [residentialAddresses, setResidentialAddresses] = useState([
    { year: 2020, state: "", from: "", to: "" },
  ]);
  const navigate = useNavigate();
  const addResidentialAddress = (index) => {
    const newYear = residentialAddresses[index]?.year + 1;
    if (!residentialAddresses.some((address) => address.year === newYear)) {
      setResidentialAddresses((prevAddresses) => [
        ...prevAddresses,
        {
          year: newYear,
          state: "",
          from: "",
          to: "",
        },
      ]);
    } else {
      // Handle the case when the year already exists (e.g., show an error message)
      // You can add your own logic here
    }
  };
  const removeResidentialAddress = (index) => {
    setResidentialAddresses((prevAddresses) =>
      prevAddresses.filter((_, i) => i !== index)
    );
  };
  return (
    <div className="clientdashboard__rentalincome_section">
      <div className="clientdashboard__rentalincome_wrapper">
        <div className="clientdashboard__rentalincome_innersection">
          <div className="clientdashboard__rentalincome_inrsecheader">
            Rental Income Info
          </div>
          <div className="clientdashboard__rentalincome_inrsecbody">
            <div className="clientdashboard__rentalincome_inrsecrow">
              <div className="clientdashboard__rentalincome_inrseccolleft">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Building value
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
              <div className="clientdashboard__rentalincome_inrseccol">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Land Value
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
            </div>
            <div className="clientdashboard__rentalincome_inrsecrow">
              <div className="clientdashboard__rentalincome_inrseccolleft">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Address of the property
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="123 Example St., City, State"
                />
              </div>
              <div className="clientdashboard__rentalincome_inrseccol">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Number of days rented during the year
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="Enter Number"
                />
              </div>
            </div>
            <div className="clientdashboard__rentalincome_inrsecrow">
              <div className="clientdashboard__rentalincome_inrseccolleft">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Date of property Purchased
                </label>
                <input
                  type="date"
                  className="clientdashboard__rentalincome_inputfield"
                />
              </div>
              <div className="clientdashboard__rentalincome_inrseccol">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Property holder
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="Enter Name"
                />
              </div>
            </div>
            <div className="clientdashboard__rentalincome_inrsecrow">
              <div className="clientdashboard__rentalincome_inrseccolleft">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Income
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
              <div className="clientdashboard__rentalincome_inrseccol">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Rents Received
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
            </div>
            <div className="clientdashboard__rentalincome_inrsecrow">
              <div className="clientdashboard__rentalincome_inrseccolleft">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Royalties Received
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
              <div className="clientdashboard__rentalincome_inrseccol">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Expenses
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
            </div>
            <div className="clientdashboard__rentalincome_inrsecrow">
              <div className="clientdashboard__rentalincome_inrseccolleft">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Mortgage Interest
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
              <div className="clientdashboard__rentalincome_inrseccol">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Other Interest
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
            </div>
            <div className="clientdashboard__rentalincome_inrsecrow">
              <div className="clientdashboard__rentalincome_inrseccolleft">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Insurance
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
              <div className="clientdashboard__rentalincome_inrseccol">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Repairs
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
            </div>
            <div className="clientdashboard__rentalincome_inrsecrow">
              <div className="clientdashboard__rentalincome_inrseccolleft">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Auto & Travel
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
              <div className="clientdashboard__rentalincome_inrseccol">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Advertising
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
            </div>
            <div className="clientdashboard__rentalincome_inrsecrow">
              <div className="clientdashboard__rentalincome_inrseccolleft">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Taxes
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
              <div className="clientdashboard__rentalincome_inrseccol">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Legal & Other Professional Fees
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
            </div>
            <div className="clientdashboard__rentalincome_inrsecrow">
              <div className="clientdashboard__rentalincome_inrseccolleft">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Cleaning & Maintenance
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
              <div className="clientdashboard__rentalincome_inrseccol">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Commissions
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
            </div>
            <div className="clientdashboard__rentalincome_inrsecrow">
              <div className="clientdashboard__rentalincome_inrseccolleft">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Utilities
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
              <div className="clientdashboard__rentalincome_inrseccol">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Management Fees
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
            </div>
            <div className="clientdashboard__rentalincome_inrsecrow">
              <div className="clientdashboard__rentalincome_inrseccolleft">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Supplies
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
              <div className="clientdashboard__rentalincome_inrseccol">
                <label className="clientdashboard__rentalincome_inputlbl">
                  Other Expenses
                </label>
                <input
                  type="text"
                  className="clientdashboard__rentalincome_inputfield"
                  placeholder="US$"
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className="clientdashboard__depndtinfo_checkboxitm2"
          style={{ border: "none" }}
        >
          <div className="clientdashboard__depndtinfo_cbicbox">
            {" "}
            <Checkbox
              defaultChecked
              sx={{
                "&.Mui-checked": {
                  color: "rgba(29, 66, 102, 1)",
                },
              }}
            />
          </div>
          <div className="clientdashboard__depndtinfo_cbirttxt">
            I declare that the Rental Income Details furnish herein are true &
            correct.
          </div>
        </div>
      </div>

      <br />
      <div className="clientdashboard__rentalincome_wrapper">
        <div className="clientdashboard__rentalincome_bottombtns">
          <button className="clientdashboard__rentalincome_bottombtn1">
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientDashboardAddRentalIncome;
